import type { SharedUiColorName } from '@/shared/ui/theming';
import { UiSpinnerComponent } from '@/ui/spinner/ui-spinner.component';
import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SharedUiColoredBackgroundColorPipe } from '../../../../libs/shared/ui/theming/lib/colors/shared-ui-color.pipe';

@Component({
    styleUrls: ['./mini-widget-icon-card.ng-cli.scss'],
    selector: 'mini-widget-icon-card',
    templateUrl: 'mini-widget-icon-card.html',
    imports: [UiSpinnerComponent, AsyncPipe, SharedUiColoredBackgroundColorPipe]
})
export class MiniWidgetIconCardComponent {
    @Input() iconImage!: string;
    @Input() isLoading!: boolean;
    @Input() clickable: boolean = false;
    @Input() color!: SharedUiColorName;
}
